import React from 'react'
import { LayoutProvider } from './layout/LayoutProvider'



export const ProviderScreen = () => {
    return (
        <LayoutProvider />
    )
}
